import './scss/index.scss';
import { dcFactory } from 'dc';
import CopyToClipboardComponent from './js/copy-to-clipboard.component';

dcFactory.register(CopyToClipboardComponent);
